/*
 * AUD-014 fix (2026-08-03): "Add to cart" gave no visual feedback because
 * ECXCartNotificationPanel.renderContents() throws when response.sections is
 * missing/incomplete (observed: "Cannot read properties of null (reading
 * 'cart-notification-panel-product')"), which aborts the method before it
 * ever calls this.open(). This patch makes per-section rendering failures
 * non-fatal so the success panel always opens after a successful add.
 * Loaded after theme.js in layout/theme.liquid; safe to remove once the
 * underlying section-rendering issue is fixed upstream.
 */
(function () {
  function patchCartNotification() {
    if (typeof ECXCartNotificationPanel === "undefined" || !ECXCartNotificationPanel.prototype) {
      return false;
    }
    if (ECXCartNotificationPanel.prototype.__aud014Patched) return true;

    ECXCartNotificationPanel.prototype.renderContents = function (response) {
      this.classList.remove("cart-notification--bundle");

      var msgEl = this.$(".js-cart-noti-msg");
      if (msgEl && msgEl.dataset.defaultText) {
        msgEl.textContent = msgEl.dataset.defaultText;
      }

      this.productId = response && response.id;

      var sectionsToRender = this.getSectionsToRender();
      var sections = (response && response.sections) || {};

      for (var i = 0; i < sectionsToRender.length; i++) {
        try {
          var target = ECXHelper.qs(sectionsToRender[i].space_selector);
          if (!target) continue;

          if (sectionsToRender[i].space_selector === "#headerCartStatus") {
            target.classList.add("header-cart-status--animate");
          }

          var sectionHtml = sections[sectionsToRender[i].id];
          if (sectionHtml) {
            target.innerHTML = this.getSectionInnerHTML(sectionHtml, sectionsToRender[i].selector);
          }
        } catch (err) {
          console.error("[aud-014-fix] failed to render cart notification section", sectionsToRender[i], err);
        }
      }

      this.open();
    };

    ECXCartNotificationPanel.prototype.__aud014Patched = true;
    return true;
  }

  if (!patchCartNotification()) {
    document.addEventListener("DOMContentLoaded", patchCartNotification);
  }
})();
